import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect, useCallback } from "react";
import { cn } from "../../lib/utils.js";
import "./shared/quiz-blank.js";
import { KatexText } from "./shared/katex-text.js";
import { useTranslation } from "react-i18next";
import "./shared/quiz-style-context.js";
import { SubmitButton } from "./shared/submit-button.js";
import "../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import { QuizMedia } from "./shared/quiz-media.js";
import "../../context/DevToolsContext.js";
import "../../utils/quiz-parser.js";
import { motion } from "../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
function FillBlankQuizForDiary({
  quizId,
  quiz,
  onSolve,
  solveResult,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  submitLabel,
  hideSubmitButton = false
}) {
  const { t } = useTranslation("quiz");
  const [startTime] = useState(() => Date.now());
  const textareaRef = useRef(null);
  const isSolved = solveResult !== null && solveResult !== void 0;
  const computedInitialAnswer = (initialAnswersProp == null ? void 0 : initialAnswersProp[0]) ?? "";
  const [answer, setAnswer] = useState(computedInitialAnswer);
  const isInitialMount = useRef(true);
  useEffect(() => {
    setAnswer(computedInitialAnswer);
  }, [computedInitialAnswer]);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (hideSubmitButton && !isSolved && !isViewSolved) {
      onSolve == null ? void 0 : onSolve(quizId, [answer], quiz.vars, Date.now() - startTime);
    }
  }, [answer, hideSubmitButton, isSolved, isViewSolved, onSolve, quizId, quiz.vars, startTime]);
  const canSubmit = answer.trim().length > 0;
  const handleAnswerChange = useCallback((value) => {
    if (isSolved || isViewSolved) return;
    setAnswer(value);
  }, [isSolved, isViewSolved]);
  const handleSubmit = useCallback(() => {
    if (!canSubmit || isSolved) return;
    const elapsedTime = Date.now() - startTime;
    onSolve == null ? void 0 : onSolve(quizId, [answer], quiz.vars, elapsedTime);
  }, [answer, canSubmit, isSolved, onSolve, quizId, quiz.vars, startTime]);
  const handleKeyDown = useCallback((e) => {
    if (e.key === "Enter" && e.shiftKey && canSubmit && !isSolved) {
      e.preventDefault();
      handleSubmit();
    }
  }, [canSubmit, isSolved, handleSubmit]);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs(
      motion.div,
      {
        initial: { opacity: 0, y: -10 },
        animate: { opacity: 1, y: 0 },
        className: "space-y-3",
        children: [
          /* @__PURE__ */ jsx("div", { className: "inline-flex gap-2 items-center px-3 py-1.5 text-sm font-bold text-white bg-linear-to-r from-emerald-500 to-teal-500 rounded-full shadow-2xs", children: /* @__PURE__ */ jsx("span", { children: t("types.newFillBlank.label") }) }),
          /* @__PURE__ */ jsx("h3", { className: "text-xl font-bold leading-relaxed text-gray-900", children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
          /* @__PURE__ */ jsx("p", { className: "text-base text-gray-400", children: t("types.newFillBlank.note") }),
          /* @__PURE__ */ jsx(QuizMedia, { image: quiz.image, imageMobile: quiz.imageMobile, desmos: quiz.desmos, vars: quiz.vars })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        initial: { opacity: 0, y: 10 },
        animate: { opacity: 1, y: 0 },
        transition: { delay: 0.1 },
        children: /* @__PURE__ */ jsx(
          "textarea",
          {
            ref: textareaRef,
            value: answer,
            onChange: (e) => handleAnswerChange(e.target.value),
            onKeyDown: handleKeyDown,
            disabled: isSolved || isViewSolved,
            placeholder: t("types.newFillBlank.placeholder"),
            rows: 4,
            className: cn(
              "w-full px-4 py-3 text-lg rounded-xl border-2 transition-all resize-none",
              "focus:outline-hidden focus:ring-2 focus:ring-offset-1",
              // 기본 상태
              !isSolved && "border-gray-200 focus:border-emerald-400 focus:ring-emerald-100",
              // 제출 후
              isSolved && "border-gray-300 bg-gray-50",
              // 비활성화
              (isSolved || isViewSolved) && "cursor-not-allowed opacity-80"
            )
          }
        )
      }
    ),
    !isSolved && !isViewSolved && !hideSubmitButton && /* @__PURE__ */ jsx(
      SubmitButton,
      {
        onClick: handleSubmit,
        disabled: !canSubmit,
        label: submitLabel ?? t("types.newFillBlank.submit")
      }
    ),
    isSolved && /* @__PURE__ */ jsx("div", { className: "p-4 text-center text-gray-600 bg-gray-100 rounded-xl", children: t("types.newFillBlank.submitted") })
  ] });
}
export {
  FillBlankQuizForDiary
};
//# sourceMappingURL=new-fill-blank-quiz.js.map
